import { render } from "./PlantwothanksView.vue?vue&type=template&id=1185bad0"
import script from "./PlantwothanksView.vue?vue&type=script&lang=js"
export * from "./PlantwothanksView.vue?vue&type=script&lang=js"

import "./PlantwothanksView.vue?vue&type=style&index=0&id=1185bad0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__